import axios from '@/plugins/axios';

const BASE_URL = '/api/instant-campaigns/';

function getAuthConfig() {
  const { key } = JSON.parse(localStorage.getItem('user') || '{}');
  return { headers: { Authorization: `Token ${key}` } };
}

export default {
  async obtenerCampanas() {
    const response = await axios.get(BASE_URL, getAuthConfig());
    return response.data;
  },

  async obtenerCampana(id) {
    const response = await axios.get(`${BASE_URL}${id}/`, getAuthConfig());
    return response.data;
  },

  async crearCampana(datos) {
    const response = await axios.post(BASE_URL, datos, getAuthConfig());
    return response.data;
  },

  async calcularDestinatarios(filtros) {
    const response = await axios.post(`${BASE_URL}calcular-destinatarios/`, filtros, getAuthConfig());
    return response.data;
  },

  async filtrarOts(filtros) {
    const response = await axios.post(`${BASE_URL}filtrar-ots/`, filtros, getAuthConfig());
    return response.data;
  },

  async enviarCampana(id) {
    const response = await axios.post(`${BASE_URL}${id}/enviar/`, {}, getAuthConfig());
    return response.data;
  },

  async obtenerMetricas(id) {
    const response = await axios.get(`${BASE_URL}${id}/metricas/`, getAuthConfig());
    return response.data;
  },
};
